import React from 'react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

let VideoPlayerComponent;
try {
  VideoPlayerComponent = require('./VideoPlayerComponent.js').default;
} catch (error) {
  VideoPlayerComponent = null;
}

const VideoPlayer = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="VideoPlayer" />;
  }

  if (!VideoPlayerComponent) {
    return <GenericPlaceholder componentName="VideoPlayer" error="Component failed to load" />;
  }

  return <VideoPlayerComponent {...props} />;
};

export default VideoPlayer;
